import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function codeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = (control.value ?? null) as string;
        if (!value) return null;
        const isValid = isStrongOtp(value);
        return isValid ? null : { otpcodeinvalid: true };
    };
}

function isStrongOtp(value: string) {
     const hasNumber = /[0-9]/u.test(value);
    const hasMinLength = value.length >= 6;
    return  hasNumber && hasMinLength;
}